import template from './ps_navbar.html';
import * as Utils from '../../lib/savanna_utils.js';
import NavbarHelper from '@platsoft/ui-ps/src/navbar/NavbarHelper.js';


class NavbarViewModel extends NavbarHelper
{
       constructor (Grape)
       {
	       super(Grape);
	       this.selected_page = ko.observable(localStorage.getItem('selected_navbar_page') || '');
	       this.company_name = ko.observable();
	       this.logo_path = ko.observable('');
	       this.use_yooma_logo = ko.observable(true);

	      	 // Listen to changes in localStorage
	       	window.addEventListener('storage', async (e) => {
		       	if (e.key === 'employee_id')
			       await Utils.refresh_data_visible_roles();
	       });
       	}	


		async init()
	       {
		       await Utils.refresh_data_visible_roles();
		       this.use_yooma_logo(Grape.config.public_settings.use_yooma_logo);
		       if (this.use_yooma_logo())
		       {
			       this.logo_path('../../lib/images/yooma-logo.png');
			       window.document.getElementById('company-name').classList.add('hrstaffhub');
			       window.document.getElementById('brand').classList.add('hrstaffhub');
		       }

		       let display_company_name = Grape.config.public_settings.display_company_name;
		       this.company_name(display_company_name);

		       // Set up observables for NavbarHelper
		       this.product_name(Grape.config.public_settings.product_name);
		       this.service_name(Grape.config.public_settings.service_name);
		       this.site_name(Grape.config.public_settings.site_name);

		       await super.init();

		       this.init_mobile_menu_close();
			   this.handle_navbar_overflow(); 

	       }
		   
		   handle_navbar_overflow()
		   {
			    const navbar = document.querySelector('.ps-nav-links');
			    const checkOverflow = () => {
			        if (navbar.scrollWidth > navbar.clientWidth) {
			            navbar.classList.add('ps-nav-overflow');
			        } else {
			            navbar.classList.remove('ps-nav-overflow');
			        }
			    };
			
			    checkOverflow();
			    window.addEventListener('resize', checkOverflow);
			}


	init_mobile_menu_close()
	{
		// Close mobile menu when any link is clicked
		const navLinks = document.querySelectorAll('.ps-nav-links a');
		navLinks.forEach(link => {
			link.addEventListener('click', () => {
				this.close_mobile_menu();
			});
		});

		// Close mobile menu when close button is clicked
		const close_btn = document.querySelector('.ps-close-btn');
		if (close_btn) 
		{
			close_btn.addEventListener('click', () => {
				this.close_mobile_menu();
			});
		}
	}

	close_mobile_menu()
	{
		const ps_menu_btn = document.getElementById('ps-menu-btn');
		if (ps_menu_btn) 
			ps_menu_btn.checked = false;
	}

	log_out_btn()
	{
		localStorage.removeItem('current_user_roles');
		window.location.href = '#/logout';
	}
}

export default {
	name: 'ko_navbar',
	viewModel: NavbarViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/ps_navbar'
}
